import $ from 'jquery';
import 'bootstrap';
import enableHomeFunctionality from './home';
import enableSaleAircraftFunctionality from './sale-aircraft';
// wait until the DOM loads
$(() => {
    // enable specific page functionality
    enableHomeFunctionality();
    // enable additional page functionality
    enableSaleAircraftFunctionality();
});
